import { Injectable ,ApplicationRef, TemplateRef,ViewChild, ElementRef} from '@angular/core';
import { environment as ENV } from '@src/environments/environment';
import { UntypedFormGroup, UntypedFormControl,Validators } from '@angular/forms';
import * as VALIDATION from '@src/app/services/form.validation';
import { HttpClient, HttpErrorResponse, HttpParams,HttpHeaders } from '@angular/common/http';
import { mergeMap } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { HttpService } from '@app/services/common-http_service/http.service'
import { ActivatedRoute, ParamMap,Router, NavigationExtras } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '@app/services/authentication/auth.service';
import { CommonService } from '@app/services/common-http_service/common.service';
import { ShortcutInput, ShortcutEventOutput } from "ng-keyboard-shortcuts";
declare var $: any;
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { switchMap } from 'rxjs/operators';
import { 
  entityFields,
  eventsTypes,
  dateFields,
  timeFields,
  urlFields,
  emailFields,
  personFields,
  timezoneFields,
  phoneFields,
  numbersFields,
  orgFields

} from '@app/config/entity_config';
import * as _LODASH from 'lodash';
import { ErrorPopupComponent } from '@templates/template2/error-popup/error-popup.component';
import { Subscription , fromEvent} from 'rxjs';
import { v4 as UUID } from 'uuid';
import { NgxSpinnerService } from "ngx-spinner";
import { VerifyActionsComponent } from '@templates/template2/verify-actions/verify-actions.component';
import * as MOMENT from 'moment';
import { JobCheckComponent } from '@templates/template2/job-check/job-check.component';




@Injectable({
  providedIn: 'root'
})

export class WorkItemsService {
    stopSubscription: Subscription;
    manualUploadFileStatus:boolean = false;
    fileUploadSuccess = false;
    autoCompleteTemplate;
    stopJobDetailsSubscription: Subscription;
    selectedjobType: string = 'ALL'
    afterWorkItemsFailed: any;
    scraper_file_id: string;
    verifyCompanyActionsJobDetails = {};
    manualDataSourceJobDetails  = {};
    dataggDataSourceJobDetails = {};
    snapShotDetails = {};
    companyDetails = {};
    eventsToggleActions : boolean = false;
    manualDataSourceDetails: any = { company_id : '', company_name: ''};
    dataggDataSourceDetails: any = { company_id : '', company_name: ''};
    stopJobDetails: Subscription;
    stopManulJobPost: Subscription;
    stopPolling: Subscription;
    stopSaveUrl: Subscription;
    ViewType: string = '';
    jobStatus: string;
    entityTrainingData = {
      text: '',
      entity_training_data: {}
    };
    predicted_event: string = ''
    selectForm: string = 'corporate_actions'
    allClass: string[] = ['date','person','org','money','percent','time','event','other'];
    init: string;
    theme: string = ENV.theme;
    text: string;
    entityRecognitionFields = {};
    sourceUrl: string;
    iframeUrl: any;
    entityText: string;
    markdown: string;
    jobId: string;
    jobtype: string;
    items: string[] =  []
    public dataSourceValidatePrediction: boolean = true;
    public scraperId: string = '';
    timeOut;
    showRefreshButton: boolean = false;
    saveUrlId: string = '';
    selectedEventTypeName: string = '';
    public count = 0;
    backward : any;
    forward  : any; 
    undoEnable = false;
    redoEnable = false;
    htmlContent : any;
    detectCookie = false;
    validateFiles: UntypedFormGroup;
    undoRedoStack: any = { undo : '', redo: ''};
    canNavigate: boolean = true;
    multipleJob: boolean = false; 
    invalidJobreason = {};
    fetchedJsonData = {};
    isJsonResLoading:boolean = false;
    verifyCompanyDetails: boolean = false;
    getIframeDetails: boolean = false;
    responseData: any = []
    htmlValue: any;
    ngAutoCompleteBack: boolean = true;
    backButton: boolean = true;
    isEventFailed: boolean = false
    //binding this fucntion in header-component
    public onSkipJob: () => void;
    onSkipped(fn: () => void) {
      this.onSkipJob = fn;
    }
    //binding this function in event-component
    public resetEventInfo:(skipped?) => void;
    onJobSkipped(fn:() => void){
      this.resetEventInfo = fn;
    }
    constructor(private refTick: ApplicationRef, private modalService:BsModalService, public commanService: CommonService, private auth : AuthService,private _http: HttpClient,private sanitizer: DomSanitizer,private route: ActivatedRoute,private router: Router, private http: HttpService, public spinner: NgxSpinnerService) {
      this.commanService.eventTypeCatch().subscribe((eventName: string) => {
        if(eventName.length > 0 && entityFields?.[eventName]?.['nonEntityes']?.length)
          this.items = eventName ? [...entityFields[eventName]['nonEntityes']] : ['company_name'];
          this.commanService.emitAutocompleteItems(this.items);
          this.selectedEventTypeName = eventName;
      })
      this.validateFiles = new UntypedFormGroup({
        url: new UntypedFormControl('',[Validators.required,VALIDATION.urlValidation]),
        file: new UntypedFormControl('',[Validators.required]),
        file_content_type: new UntypedFormControl(''),
        file_name: new UntypedFormControl('',[VALIDATION.fileExtentions])
      }, {validators: [VALIDATION.validateManulFilesForm()]})
    }

    get validateManulFilesForm() {
      return this.validateFiles;
    }
    public jobDetailsType = '';
    getJobDetails(id:string) {
      this.stopJobDetailsSubscription = this._http.get(`${ENV.workItemsApi}/jobs/${id}`).subscribe((data: any) => {
        // this.jobId = data.data.items.id;
        // this.jobtype = 'WORK_ITEM';
        this.scraperId = data.data.items.job_details.source_id;
        this.jobDetailsType = data.data.items.job_details.type;
        this.getScraperJobDetails(this.scraperId);
      })
    }
    getjob() {
      // let skills = JSON.parse(localStorage.getItem('userSkillsInfo'));
      // let skillsPayload: any = (skills.length) ? {skills:skills} : '';
      this.spinner.show();
      let queryStrings = {};
      let jobEndPoint = 'DATA_AGGREGATION';
      if(['DATA_SOURCE_VALIDATE_PREDICTION','DATA_SOURCE_URL_FAILED','DAGGR_VERIFY_COMPANY_ACTIONS'].includes(this.selectedjobType)) {
        // skills = {
        //   skills:[{
        //     name: this.selectedjobType,
        //     type: this.selectedjobType,
        //     rating: 5
        //   }],
        //   only_by_skill: true
        // }
        // skillsPayload = {...skills}
        // if(this.selectedjobType === 'DAGGR_VERIFY_COMPANY_ACTIONS') jobEndPoint = 'DAGGR_VERIFY_COMPANY_ACTIONS';
        queryStrings['queue_name'] = ENV['queues_info'][this.selectedjobType];
      } else {
        let queue_user_type = 'daggr_operator'
        if(('cognito:groups' in this.auth.getIdToken && this.auth.getIdToken['cognito:groups'].length && this.auth.getIdToken['cognito:groups'].includes('daggr_tl')))  { 
          queue_user_type = 'daggr_tl'
        }
        queryStrings['user_type'] = queue_user_type;
      }
      // let api = this._http.post(`${ENV.workItemsApi}/get-job/${jobEndPoint}`,skillsPayload)
      if(('cognito:groups' in this.auth.getIdToken && this.auth.getIdToken['cognito:groups'].length && this.auth.getIdToken['cognito:groups'].includes('daggr_freelancer')))  {
        queryStrings = {}
        if(this.selectedjobType !== 'DAGGR_VERIFY_COMPANY_ACTIONS') {
          // if(skillsPayload) {
          //   skillsPayload['job_pool'] = 'HISTORICAL_POOL';
          // } else {
          //   skillsPayload = {};
          //   skillsPayload['job_pool'] = 'HISTORICAL_POOL';
          //   skillsPayload['skills'] = [{
          //     name: 'DATA_AGGREGATION',
          //     type: 'DATA_AGGREGATION',
          //     rating: 5
          //   }]
          // }
          // skillsPayload['only_by_skill'] = true;
          queryStrings['queue_name'] = ENV['queues_info']['HISTORICAL_POOL'];
        }
      }
      let api = this._http.get(`${ENV.workItemsApi}/get-job-by-queue`,{params: queryStrings})
      this.stopSubscription = api.subscribe((data: any) => {
        this.jobStatus = 'IN_PROGRESS';
        this.canNavigate = false;
          if(data.data.items && 'job_details' in data.data.items ) {
            this.auditTrailJobStateActions({action_type:'JOB_STARTED',source_id: data.data.items.id});
            this.jobtype = 'WORK_ITEM';
            setTimeout( () => {  this.jobId = data.data.items.id; },300);
            if(this.selectedjobType !== 'DAGGR_VERIFY_COMPANY_ACTIONS') {
              if('job_details' in data.data.items && 'source_id' in data.data.items.job_details ) {
                this.scraperId = data.data.items.job_details.source_id;
                this.jobDetailsType = data.data.items.job_details.type;
                if(data.data.items.job_details.type === 'DATA_SOURCE_VALIDATE_PREDICTION') {
                  this.dataSourceValidatePrediction = true;
                  this.articleViweName ='iframe';
                  if(this.scraperId && data.data.items.job_details.source_type === 'SCRAPER')
                    this.getScraperJobDetails(this.scraperId);
                  else  {
                    this.spinner.hide();
                    const initialState = {
                      errors:{
                        message: 'Invalid job'
                      }
                    };
                    this.invalidJobreason =  {work_items: 'invalid job'};
                    this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
                  }
                } else if(data.data.items.job_details.type === 'DATA_SOURCE_URL_FAILED')  {
                  // alert('Broken Url');
                  //this.getSkills();
                  let brokenUrlRecordId = data.data.items.job_details.source_id;
                  if('details' in  data['data']['items']['job_details'] && data['data']['items']['job_details']['details'] && 'source_id' in data['data']['items']['job_details']['details'] && 'source_type' in data['data']['items']['job_details']['details'] && data['data']['items']['job_details']['details']['source_type'] === 'DAGGER_COMPANY_DATA_SOURCE_ID' && data['data']['items']['job_details']['details']['source_id']) {
                    brokenUrlRecordId = `DATA_SOURCE_ID:${data['data']['items']['job_details']['details']['source_id']}`
                  }
                  this.spinner.hide();
                  if(this.scraperId)
                    this.canNavigate = true;
                    this.router.navigate(['template2/data-source',data.data.items.job_details.type,brokenUrlRecordId,data.data.items.id]);
                  this.stopSubscription.unsubscribe();
                  return;
                } else if(this.jobDetailsType === 'MANUAL_DATASOURCE') {
                    this.spinner.hide();
                    this.manualDataSourceJobDetails = {...data.data.items.job_details};
                    this.sourceUrl = ('details' in data.data.items.job_details) ? data.data.items.job_details['details']['url'] : '';
                    if(
                      'details' in data.data.items.job_details && 
                      'company_id' in data.data.items.job_details['details']
                    ) {
                      this.manualDataSourceDetails = { company_id:data.data.items.job_details['details']['company_id'],company_name: data.data.items.job_details['details']['company_name']}
                      this.getSnapShotDetails(data.data.items.job_details['details']['company_id']);
                    }
                }
               else {
                  // Getting job Details
                  if(this.scraperId && data.data.items.job_details.source_type === 'SCRAPER') {
                    this.getScraperJobDetails(this.scraperId);
                    this.dataggDataSourceJobDetails = {...data.data.items.job_details};
                    if(
                      'details' in data.data.items.job_details && 
                      'company_id' in data.data.items.job_details['details']
                    ) {
                      this.dataggDataSourceDetails = { company_id:data.data.items.job_details['details']['company_id'],company_name: data.data.items.job_details['details']['company_name']}
                      // this.getcomapnyDetails(data.data.items.job_details['details']['company_id']);
                    }
                  } else {
                    this.spinner.hide();
                    this.invalidJobreason =  {work_items: 'invalid job'}
                    const initialState = {
                      errors:{
                        message: 'Invalid job'
                      }
                    };
                    this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
                  }
                }
              }
            } else {
              // console.log( 'test',data.data.items);
              // this.spinner.hide();
              setTimeout( () => {
                this.jobId = data.data.items.id;
                this.verifyCompanyActionsJobDetails = data.data.items.job_details;
                this.switchCards(data.data.items.job_details['company_action']);
                this.jobDetailsType = data.data.items.service_type;
              },200)
            }
          }
      },((error: HttpErrorResponse )=> {
        this.spinner.hide();
        this.canNavigate = true;
        console.log('ERROR OCCURED',(error.status === 400 && 'errors' in error.error));
        let workItemErrorMessages = {};
        workItemErrorMessages['message'] = 'Something went wrong. Please contact the administrator.'
        if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data || error.status === 400 && 'errors' in error.error ) {
          if(error.status === 400 && 'errors' in error.error) workItemErrorMessages = {...error.error.errors}
          if(error.status === 400 && 'data' in error.error && 'errors' in error.error.data) workItemErrorMessages = {...error.error.data.errors}
        }
        let config = {
          class:'modal-dialog-centered',
          ignoreBackdropClick: true,
          keyboard: false
        }
        setTimeout(() => {
          this.modalRef = this.modalService.show(this.afterWorkItemsFailed, config);
        },300)
        // this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
      }))
      // .pipe(mergeMap( (data: any) => { 
      //     if(data.data.items && 'job_details' in data.data.items) {
      //       // console.log(data.data.items.id);
      //       this.jobId = data.data.items.id;
      //       this.jobtype = 'WORK_ITEM'
      //       if('job_details' in data.data.items && 'source_type' in data.data.items.job_details )
      //         if(data.data.items.job_details.type === 'DATA_SOURCE_VALIDATE_PREDICTION') {
      //           this.dataSourceValidatePrediction = true;
      //         } else if(data.data.items.job_details.type === 'DATA_SOURCE_URL_FAILED')  {
      //           alert('Broken Url');
      //           //this.getSkills();
      //           this.router.navigate(['template2/data-source',data.data.items.job_details.type,data.data.items.job_details.source_id,this.jobId]);
      //           this.stopSubscription.unsubscribe();
      //           return of('')
      //         }
      //         this.scraperId = data.data.items.job_details.source_id;
      //       // return this._http.get(`https://3wgq1u5wlk.execute-api.us-east-1.amazonaws.com/r6/files/93bfffdd-c311-4c95-ba45-7422ed7baff2`)
      //       return this._http.get(`${ENV.scraperApi}/files/${data.data.items.job_details.source_id}`)
      //     } else {
      //       return of('')
      //     }
      // })).pipe(mergeMap( (files: any) => { 
      //     if(files.data.items) {
      //       this.sourceUrl = files.data.items.source_url;
      //       if( files.data.items.primary_source_type && files.data.items.primary_source_type === 'pdf'){
      //         this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(files.data.items.pdf_url);
      //       } else {
      //         this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(files.data.items.html_url);
      //       }
      //       return this._http.get(`${files.data.items.markdown_url}`,{ responseType: 'text'});
      //     } else {
      //       return of('')
      //     }
      // })).pipe(mergeMap((text)=> {
      //   if(!text) {
      //     return of('');
      //   } else {
      //     let recivedText = text;
      //     let removeIframe = recivedText.replace(/<iframe.*>.*?<\/iframe>/ig,'');
      //     let removeImg = removeIframe.replace(/<img[^>]*>/g,"");
      //     let removescripts = this.stripScripts(removeImg,'script');
      //     let removeStyles = this.stripScripts(removescripts,'style');
      //     this.text = removeStyles;
      //     return this.http.entityPost('entities',{text: this.text})
      //   }
      // }))       
      // .subscribe(
      //   (data: any) => {
      //     if(data){
      //       let entity_Text = this.text;
      //       let markdownText = this.text;
      //       let entityTextIndex = 0;
      //       let markdownTextIndex = 0;
      //         data.entities.forEach((item, index) => {
      //           let className = '';
      //           if(item.entity_label === 'DATE') {
      //               className = 'date';
      //           } else if (item.entity_label === 'PERSON') {
      //               className = 'person';
      //           } else if (item.entity_label === 'ORG') {
      //             className = 'org';
      //           } else if (item.entity_label === 'MONEY') {
      //             className = 'money';
      //           } else if (item.entity_label === 'PERCENT') {
      //             className = 'percent';
      //           } else if (item.entity_label === 'TIME') {
      //             className = 'time';
      //           }  else if (item.entity_label === 'EVENT') {
      //             className = 'event';
      //           } else {
      //             className = 'other';
      //           }
      //           let textIndex = entity_Text.indexOf(item.entity_text,entityTextIndex);
      //           // if(textIndex !== -1) {
      //             // console.log(item.entity_text,textIndex);
      //             let replaceWith = `<span class='${className} entityActiions' (click)="context.selectedContent('${item.entity_label}','${item.entity_text}')" title='${item.entity_label}'>${item.entity_text}</span>`;
      //             entity_Text = entity_Text.substr(0,textIndex) + replaceWith + entity_Text.substr(textIndex + item.entity_text.length,entity_Text.length);
      //             // console.log(index,item.entity_text,textIndex);
      //             //entityTextIndex = entity_Text.substring(0,textIndex).length - 1;
      //             entityTextIndex = entity_Text.lastIndexOf(replaceWith)+replaceWith.length -1 ;
    
    
      //             let markDownIndex = markdownText.indexOf(item.entity_text,markdownTextIndex);
      //               let markDownreplaceWith = `<mark class='${className} entityActiions' title='${item.entity_label}'>${item.entity_text}</mark>`;
      //               markdownText = markdownText.substr(0,markDownIndex) + markDownreplaceWith + markdownText.substr(markDownIndex + item.entity_text.length,markdownText.length);
      //               markdownTextIndex = markdownText.lastIndexOf(markDownreplaceWith)+markDownreplaceWith.length -1 ;
      //         });
      //         this.entityText = entity_Text;
      //         this.markdown = markdownText;
      //         setTimeout(()=> {
      //           this.entityActions();
      //           this.removeEntityClasses(this.allClass);
      //         })
      //     }
      //   },((error: HttpErrorResponse )=> {
      //     // alert('No jobs available.');
      //     console.log('ERROR OCCURED',error);
      //     console.log('ERROR OCCURED',(error.status === 400 && 'errors' in error.error));
      //     if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data || error.status === 400 && 'errors' in error.error ) {
      //       let errorsMessages = {};
      //       if(error.status === 400 && 'errors' in error.error) errorsMessages = {...error.error.errors}
      //       if(error.status === 400 && 'data' in error.error && 'errors' in error.error.data) errorsMessages = {...error.error.data.errors}
      //       const initialState = {
      //         errors: errorsMessages,
      //       };
      //       this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
      //     }
      //   })
      // )
    }

    // Get SnapShot Details
    getSnapShotDetails(companyId: string) {
      this.http.snapShot(companyId).subscribe((data: any) => { 
        this.snapShotDetails = {...data['data']['items']}
      })
    }

    // Get comapny Details
    getcomapnyDetails(companyId: string) {
          this.http.companyData(companyId).subscribe((data: any) => { 
            this.companyDetails = {...data['data']['items']}
            this.dataggDataSourceDetails.company_name = {...data['data']['items']['company_name']}
          })
        }
    // 
    eventsToggle(){
      this.eventsToggleActions = !this.eventsToggleActions;
    }
    getScraperJobDetails(id: string) {
      this.scraper_file_id = id;
      this.predicted_event = '';
      this.stopJobDetails = this._http.get(`${ENV.scraperApi}/files/${id}`).pipe(mergeMap( (files: any) => { 
        if(files.data.items) {
          this.sourceUrl = files.data.items.source_url;
          if(files.data.items.predicted_event_type) {
            let splitedData = files.data.items.predicted_event_type.split(',');
            splitedData.forEach((predicted_event_type
              ) => {
              this.predicted_event += `${eventsTypes[predicted_event_type] ? eventsTypes[predicted_event_type] : predicted_event_type} \n`
          })
          }
          if( files.data.items.primary_source_type && files.data.items.primary_source_type === 'pdf'){
            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(files.data.items.pdf_url);
          } else {
            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(files.data.items.html_url);
          }
          if('entity_content' in files.data.items && 'entities' in files.data.items['entity_content'] && files.data.items['entity_content']['entities'].length) {
            this.entityRecognitionFields = {...files.data.items['entity_content']};
            //this.fetchedJsonData = {...files.data.items['entity_content']};
            //this.isJsonResLoading = false;
          }
          return this._http.get(`${files.data.items.markdown_url}`,{ responseType: 'text'});
        } else {
          return of('')
        }
      })).pipe(mergeMap((text)=> {
        if(!text) {
          return of('');
        } else {
          let recivedText = text;
          let removeIframe = recivedText.replace(/<iframe.*>.*?<\/iframe>/ig,'');
          let removeImg = removeIframe.replace(/<img[^>]*>/g,"");
          let removescripts = this.stripScripts(removeImg,'script');
          let removeStyles = this.stripScripts(removescripts,'style');
          this.text = removeStyles;
          if(this.entityRecognitionFields['entities']) return of(this.entityRecognitionFields)
          else return this.http.entityPost('entities',{text: this.text})
        }
      }))       
      .subscribe(
        (data: any) => {
          if(data){
            this.spinner.hide();
            let entity_Text = this.text;
            let markdownText = this.text;
            let entityTextIndex = 0;
            let markdownTextIndex = 0;
              data.entities.forEach((item, index) => {
                let className = '';
                if(item.entity_label === 'DATE') {
                    className = 'date';
                } else if (item.entity_label === 'PERSON') {
                    className = 'person';
                } else if (item.entity_label === 'ORG') {
                  className = 'org';
                } else if (item.entity_label === 'MONEY') {
                  className = 'money';
                } else if (item.entity_label === 'PERCENT') {
                  className = 'percent';
                } else if (item.entity_label === 'TIME') {
                  className = 'time';
                }  else if (item.entity_label === 'EVENT') {
                  className = 'event';
                } else {
                  className = 'other';
                }
                let textIndex = entity_Text.indexOf(item.entity_text,entityTextIndex);
                // if(textIndex !== -1) {
                  // console.log(item.entity_text,textIndex);
                  let replaceWith = `<span class='${className} entityActiions' (click)="context.selectedContent('${item.entity_label}','${item.entity_text}')" title='${item.entity_label}'>${item.entity_text}</span>`;
                  entity_Text = entity_Text.substr(0,textIndex) + replaceWith + entity_Text.substr(textIndex + item.entity_text.length,entity_Text.length);
                  // console.log(index,item.entity_text,textIndex);
                  //entityTextIndex = entity_Text.substring(0,textIndex).length - 1;
                  entityTextIndex = entity_Text.lastIndexOf(replaceWith)+replaceWith.length -1 ;
    
    
                  let markDownIndex = markdownText.indexOf(item.entity_text,markdownTextIndex);
                  if(markDownIndex > -1) {
                    let markDownreplaceWith = `<mark class='${className} entityActiions' title='${item.entity_label}'>${item.entity_text}</mark>`;
                    markdownText = markdownText.substr(0,markDownIndex) + markDownreplaceWith + markdownText.substr(markDownIndex + item.entity_text.length,markdownText.length);
                    markdownTextIndex = markdownText.lastIndexOf(markDownreplaceWith)+markDownreplaceWith.length -1 ;
                  } else  markDownIndex + item.entity_text.length - 1
              });
              this.entityText = entity_Text;
              this.markdown = markdownText;
              setTimeout(()=> {
                this.entityActions();
                this.removeEntityClasses(this.allClass);
              })
          }
        },((error: HttpErrorResponse )=> {
          // alert('No jobs available.');
          //this.isJsonResLoading = false;
          console.log('ERROR OCCURED',error);
          this.spinner.hide();
          console.log('ERROR OCCURED',(error.status === 400 && 'errors' in error.error));
          if( ( error.status === 400  ||  error.status === 404 ) && 'data' in error.error && 'errors' in error.error.data || ( error.status === 400  ||  error.status === 404 ) && 'errors' in error.error ) {
            let errorsMessages = {};
            if(( error.status === 400  ||  error.status === 404 ) && 'errors' in error.error) errorsMessages = {...error.error.errors}
            if(( error.status === 400  ||  error.status === 404 ) && 'data' in error.error && 'errors' in error.error.data) errorsMessages = {...error.error.data.errors}
            const initialState = {
              errors: errorsMessages,
            };
            this.invalidJobreason =  {scraper: errorsMessages}
            this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
          }
        })
      )
    }


    unscbscribe() {
      // console.log(this.stopSubscription);
      if(this.timeOut)
        clearTimeout(this.timeOut)
      if(this.stopSubscription)
        this.stopSubscription.unsubscribe()
      if(this.stopJobDetailsSubscription)
        this.stopJobDetailsSubscription.unsubscribe()
      if(this.stopJobDetails)
        this.stopJobDetails.unsubscribe()
      if(this.stopSaveUrl)
        this.stopSaveUrl.unsubscribe()
      if(this.stopPolling)
        this.stopPolling.unsubscribe()
      if(this.stopManulJobPost)
        this.stopManulJobPost.unsubscribe()
    }
    getNewJob() {
      setTimeout(() => {
        this.validateFiles.reset();
        this.validateFiles.enable();
        this.manualUploadFileStatus = false;
      })
        
      if(this.jobDetailsType === 'MANUAL_JOB') {
        this.initRssVariables();
        this.initArticleVariable();
        this.createManualJob({});
      } else {
        this.initRssVariables();
        this.initArticleVariable();
        this.getSkills();
      }
      this.closeModalPopUps(false);
    }

    closeModalPopUps(action = true) {
      if(this.modalRef)
        this.modalRef.hide();
      if(action)
        this.router.navigate(['template2/default']);
    }

    // copy to clip board
    copyClipboard(url:string) {
      if(!url) return;
      let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = url;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }
    // // complete job
    jobCompleted(details: any, confrimTemplate?, logout=false) {
      this.spinner.show();
      this._http.put(`${ENV.workItemsApi}/jobs/${this.jobId}`,{job_status: 'DONE'}).subscribe((data: any) => {
        this.jobStatus = 'COMPLETED';
        this.canNavigate = true;
         this.spinner.hide();
        if(confrimTemplate){
          this.showAfterConfirmTemplate(confrimTemplate, true);
        }
        this.auditTrailJobStateActions({action_type:'JOB_COMPLETED',source_id: this.jobId});
        if(Object.keys(details).length && !details['template']) {
          if(details['endpoint']){
            setTimeout(() => this.router.navigateByUrl(`template2/${details['endpoint']}`), 1000);
          }
          this.multipleJob = false;
          this.jobDetailsType = '';
          if(logout)  this.auditTrailLoginActions('SIGN_OUT',{action_type:'SIGN_OUT'});
        } else {
          let config = {
            class:'modal-dialog-centered',
            ignoreBackdropClick: true,
            keyboard: false
          }
          setTimeout(()=> this.modalRef = this.modalService.show(details['template'], config), 3000);
          this.jobId = '';
          this.scraper_file_id = '';
          this.invalidJobreason = '';
          this.spinner.hide();
          // if(this.jobDetailsType === 'MANUAL_JOB') {
            // this.initRssVariables();
            // this.initArticleVariable();
            // this.createManualJob({});
          // } else {
            // this.initRssVariables();
            // this.initArticleVariable();
            if(['DATA_SOURCE_VALIDATE_PREDICTION','DATA_SOURCE_URL_FAILED','DAGGR_VERIFY_COMPANY_ACTIONS'].includes(this.jobDetailsType)) {
              this.selectedjobType =  this.jobDetailsType;
            // }
            // this.getSkills();
          }
        }
      },((error: HttpErrorResponse )=> {
        this.spinner.hide();
        console.log('ERROR OCCURED',error);
        console.log('ERROR OCCURED',(error.status === 400 && 'errors' in error.error));
        if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data || error.status === 400 && 'errors' in error.error ) {
          let errorsMessages:any = {};
          if(error.status === 400 && 'errors' in error.error) errorsMessages = {...error.error.errors}
          if(error.status === 400 && 'data' in error.error && 'errors' in error.error.data) errorsMessages = {...error.error.data.errors}
          const initialState = {
            errors: errorsMessages['message'] ? errorsMessages['message'] : errorsMessages
          };
          this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
        }
      }))
    }

    cardName = 'corporate_actions';
    getAttributes(title: string) {
      switch(this.cardName) {
        case 'company_database':
        case 'company_database_update':
        case 'add_ticker_information':
          // if(this.tabName === 'company') {
          //   if(title === 'DATE') {
          //     return [{title: 'start_date', cmd: 'start_date'}, {title: 'end_date', cmd: 'end_date'}];
          //   }
          // } else if(this.tabName === 'securities') {
          //   if(title === 'DATE') {
            if(title === 'DATE') {
              let companydDatabaseMenu = [...entityFields[this.selectedEventTypeName]['DATE']];
              this.dynamicEntityFields.forEach((menu) => {
                if(!(_LODASH.some(companydDatabaseMenu, menu))) { 
                  companydDatabaseMenu.push(menu)
                }
              });
              return companydDatabaseMenu
            } 
          //   }
          // }
          break;
        case 'merger':
        case 'spin_off':
            if(title === 'ORG') {
              let orgMenu = [...entityFields[this.selectedEventTypeName]['ORG']];
              this.dynamicEntityFields.forEach((menu) => {
                if(!(_LODASH.some(orgMenu, menu))) { 
                  orgMenu.push(menu)
                }
              });
              return orgMenu
            }
            if(title === 'DATE') {
              if(entityFields[this.selectedEventTypeName]['DATE']) {
                let companydDatabaseMenu = [...entityFields[this.selectedEventTypeName]['DATE']];
                return companydDatabaseMenu
              }
            }
          break;
        case 'add_persons':
            if(title === 'ORG') {
              let orgMenu = [];
              this.dynamicAddpersonsCompany.forEach((menu) => {
                if(!(_LODASH.some(orgMenu, menu))) { 
                  orgMenu.push(menu)
                }
              });
              return orgMenu
            }
            if(title === 'DATE') {
              let personsDataBaseMenu = [...entityFields[this.selectedEventTypeName]['DATE']];
              this.dynamicEntityFields.forEach((menu) => {
                if(!(_LODASH.some(personsDataBaseMenu, menu))) { 
                  personsDataBaseMenu.push(menu)
                }
              });
              return personsDataBaseMenu
            }
          break;
          case 'liquidation':
          case 'bankruptcy':
          case 'company_name_change':
          case 'exchange_ticker_change':
          case 'head_quarters_change':
          case 'acquisition':
          case 'delisted':
          case 'securities':
              // if(title === 'DATE') {
              if(entityFields[this.selectedEventTypeName][title]) {
                let companydDatabaseMenu = [...entityFields[this.selectedEventTypeName][title]];
                return companydDatabaseMenu
              }
              // } 
            break;
        case 'corporate_actions':
          if(this.selectedEventTypeName) {
            if(title === 'DATE') {
              return entityFields[this.selectedEventTypeName]['DATE']
            } else if(title === 'TIME') {
              if(entityFields[this.selectedEventTypeName]['TIME'])
                return entityFields[this.selectedEventTypeName]['TIME']
            }
          }

          // if(title === 'DATE') { 
          //   return [{title: 'event_date', cmd: 'event_date'},{title: 'period_end_date' ,cmd: 'period_end_date'}]
          // } else if(title === 'TIME') {
          //   return [{title: 'event_time', cmd: 'event_time'}]
          // }
          break;
        case 'products':
          if(title === 'DATE') { 
            return [{title: 'start_date', cmd: 'start_date'}, {title: 'end_date', cmd: 'end_date'}];
          }
          break;
      }
    }
    entityActions() {
      const self = this;
      $(document).contextmenu({
        delegate: ".entityActiions",
        autoFocus: true,
        // preventSelect: true,
        // preventContextMenuForPopup: true,
        // taphold: false,
        position: function(event, ui){
          return {my: "left top", at: "left bottom", of: ui.target};
        },
        // Handle menu selection to implement a fake-clipboard
        select: function(event, ui) {
          // creating range
          let data = {};
          var $target = ui.target;
          // let range = new Range();
          // range.setStart( ui.target[0], 0);
          // range.setEnd( ui.target[0], 0);
          // let afterPostions: any = self.getSelectionCharOffsetsWithin(range)
          // if(afterPostions['end'] !== null && afterPostions['start'] !== null) {}
          //   afterPostions['end'] = afterPostions['start'] + $target.text().length;

          // self.emitData({key: ui.cmd, data: data});
          if(ui.cmd.indexOf("-") > 0) {
            let eventArray = ui.cmd.split('-');
            let postion = parseInt(eventArray[eventArray.length-1]);
            data[ui.cmd.split('-')[0]] = $target.text();
            self.getPositionsForContext(ui.target[0], $target.text(),ui.cmd.split('-')[0],ui.cmd);
            self.commanService.entityRecongEmit({key: ui.cmd.split('-')[0], data: data, postion:true, positionNumber: postion })
          } else {
            data[ui.cmd] = $target.text();
            self.getPositionsForContext(ui.target[0], $target.text(),ui.cmd,ui.cmd);
            self.commanService.entityRecongEmit({key: ui.cmd, data: data})
          }
          // self.commanService.entityRecongEmit({key: ui.cmd, data: data})
          // Optionally return false, to prevent closing the menu now
        },
        // Implement the beforeOpen callback to dynamically change the entries
        beforeOpen: function(event, ui) {
          let title = ui.target.attr('title');
          if(!title) 
            return  false;
          // console.log('$target.text()', ui.target.text())
          let notIclude = ['acquisition','company_name_change','merger','spin_off','add_persons']
          if(!notIclude.includes(self.cardName)) {
            if(title === 'ORG') {
              self.getPositionsForContext(ui.target[0], ui.target.text(),'company_name','company_name');
              self.commanService.entityRecongEmit({key: 'company_name', data: {company_name: ui.target.text()} });
              return false
            }
          }
          if(title === 'PERSON' && self.cardName === 'add_persons') { 
            self.getPositionsForContext(ui.target[0], ui.target.text(),'person_name','person_name');
            self.commanService.entityRecongEmit({key: 'person_name', data: {person_name: ui.target.text()} });
            return false
          }
          let menu  = self.getAttributes(title);
          if(!menu)
            return false;
          $(document).contextmenu("replaceMenu", menu)
          return true;
        }
      });
    }
    stripScripts(domValue, tag) {
      var div = document.createElement('div');
      div.innerHTML = domValue;
      var htmlTags = div.getElementsByTagName(tag);
      var i = htmlTags.length;
      while (i--) {
          htmlTags[i].parentNode.removeChild(htmlTags[i]);
      }
      return div.innerHTML;
    }
    getSkills() {
      // if(!localStorage.getItem('userSkillsInfo')) {
      //   this._http.get(`${ENV.ssoApi}/users/${this.auth['getIdToken']['cognito:username']}/skills`).subscribe((userSkillsInfo : any) => {
      //     localStorage.setItem('userSkillsInfo', JSON.stringify(userSkillsInfo['data']['items']));
      //     this.getjob();
      //   })
      // } else {
        this.getjob();
      // }
    }
    // tracking user actions
    auditTrailLoginActions(loginType: string, body: any) {
      body['action_start_at'] = MOMENT().utc().format();
      if(loginType === 'SIGN_IN') {
        if(!localStorage.getItem('userAction')) { 
          this._http.post(`${ENV['apiUrl']}/audit`,{...body}).subscribe((res) => {
            localStorage.setItem('userAction', 'SIGN_IN');
          })
        }
        return;
      } else if(loginType === 'SIGN_OUT') {
        this.spinner.show();
        this._http.post(`${ENV['apiUrl']}/audit`,{...body}).subscribe((res) => {
          localStorage.removeItem('userAction');
          this.auth.signOut();
        },(error) => {
          this.auth.signOut();
        });
        return;
      }
    }
    // tracking job state actions
    auditTrailJobStateActions(body: any) {
      if(body['action_type'] === 'FORM_OPEN') {
        body['endpoint'] = this.router.url;
      }
      body['action_start_at'] = MOMENT().utc().format();
      this._http.post(`${ENV['apiUrl']}/audit`,{...body}).subscribe((res) => {
        console.info('success');
      })
    };
    public articleViweName = 'markdown';
    articleViwe(type: string, event: any) {
      event.preventDefault();
      this.articleViweName = type;
      setTimeout(()=> {
        this.entityActions();
        if(type === 'markdown') {
          this.removeEntityClasses(this.allClass);
        }
      })
    }

    //Handling Short cuts

    shortcuts: ShortcutInput[] = [
      {
        key: ["f8"],
        label: "commaon",
        description: "f8",
        command: (output: ShortcutEventOutput) => { this.commonAction() },
        preventDefault: true
      },
      {
        key: ["shift + c"],
        label: "company",
        description: "shift + c",
        command: (output: ShortcutEventOutput) => { this.articleActions('company_name','ORG'); },
        preventDefault: true
      },
      {
        key: ["shift + y"],
        label: "year",
        description: "shift + y",
        command: (output: ShortcutEventOutput) => { this.articleActions('financial_year','YEAR');},
        preventDefault: true
      },{
        key: ["shift + t"],
        label: "event title",
        description: "shift + t",
        command: (output: ShortcutEventOutput) => { this.articleActions('title','EVENT');},
        preventDefault: true
      },
      {
        key: ["shift + a"],
        label: "announcement date",
        description: "shift + a",
        command: (output: ShortcutEventOutput) => { this.articleActions('announcement_date','DATE');},
        preventDefault: true
      },
      {
        key: ["shift + p"],
        label: "period end date",
        description: "shift + p",
        command: (output: ShortcutEventOutput) => { this.articleActions('period_end_date','DATE');},
        preventDefault: true
      },
      {
        key: ["shift + e"],
        label: "event date",
        description: "shift + e",
        command: (output: ShortcutEventOutput) => { this.articleActions('event_date','DATE');},
        preventDefault: true
      },
      {
        key: ["shift + f"],
        label: "finacial quarter",
        description: "shift + f",
        command: (output: ShortcutEventOutput) => { this.articleActions('financial_quarter','QUARTER');},
        preventDefault: true
      },
      {
        key: ["shift + r"],
        label: "replay webcast url",
        description: "shift + r",
        command: (output: ShortcutEventOutput) => { this.articleActions('replay_webcast_url','URL'); },
        preventDefault: true
      },
      {
        key: ["shift + l"],
        label: "replay webcast url",
        description: "shift + l",
        command: (output: ShortcutEventOutput) => { this.articleActions('live_webcast_url','URL'); },
        preventDefault: true
      },
      {
        key: ["l p"],
        label: "live phone us",
        description: "l p",
        command: (output: ShortcutEventOutput) => { this.articleActions('live_phone_us','NUMBER'); },
        preventDefault: true
      },
      {
        key: ["l s"],
        label: "live passcode us",
        description: "l s",
        command: (output: ShortcutEventOutput) => { this.articleActions('live_passcode_us','NUMBER'); },
        preventDefault: true
      },
      {
        key: ["r p"],
        label: "Replay phone us",
        description: "r p",
        command: (output: ShortcutEventOutput) => { this.articleActions('replay_phone_us','NUMBER'); },
        preventDefault: true
      },
      {
        key: ["r s"],
        label: "Replay passcode us",
        description: "r s",
        command: (output: ShortcutEventOutput) => { this.articleActions('replay_passcode_us','NUMBER'); },
        preventDefault: true
      },
      // {
      //   key: ["alt + c"],
      //   label: "company",
      //   description: "company",
      //   command: (output: ShortcutEventOutput) => { this.switchCards('company'); },
      //   preventDefault: true
      // },
      // {
      //   key: ["alt + e"],
      //   label: "corporate_actions",
      //   description: "corporate_actions",
      //   command: (output: ShortcutEventOutput) => { this.switchCards('corporate_actions'); },
      //   preventDefault: true
      // }
      // ,
      // {
      //   key: ["shift + p"],
      //   label: "persons",
      //   description: "persons",
      //   command: (output: ShortcutEventOutput) => { this.switchCards('persons'); },
      //   preventDefault: true
      // }
      // ,
      {
        key: ["alt + shift + d"],
        label: "dev",
        description: "dev tools",
        command: (output: ShortcutEventOutput) => { this.toogleActions(); },
        preventDefault: true
      },
      {
        key: ["alt + t"],
        label: "toggle",
        description: "toggle",
        command: (output: ShortcutEventOutput) => { this.toggleEntityes() },
        preventDefault: true
      }
    ];


    public enableDevOptions = false

    toogleActions() {
      console.log('error',)
      this.enableDevOptions = !this.enableDevOptions;
    }
    switchCards(cardName: string) {
      this.cardName = cardName;
      if(this.cardName !== 'corporate_actions') {
        this.commanService.eventType(cardName)
      }
    }
    buildTraningData(data) {
      let elementInfo = document.getElementById('entityEecognitionTextElement');

      if(!this.scraper_file_id || !elementInfo) return;

      this.entityTrainingData['text'] = elementInfo.textContent;
      if(['educations:start_date','work_history:start_date'].includes(data['entity_label'])) {
        data['entity_label']  =  data.entity_label.split(':')[1];
      }

      this.entityTrainingData['file_fields'] = {
        scraper_file_id: this.scraper_file_id,
        url: this.sourceUrl
      }
      if(orgFields.includes(data['entity_label'])) {
        data['entity_label'] = 'ORG';
      } else if(dateFields.includes(data['entity_label'])) {
        data['entity_label'] = 'DATE';
      } else if(timeFields.includes(data['entity_label'])) {
        data['entity_label'] = 'TIME';
      } else if(urlFields.includes(data['entity_label'])) {
        data['entity_label'] = 'URL';
      } else if(emailFields.includes(data['entity_label'])) {
        data['entity_label'] = 'EMAIL';
      } else if(personFields.includes(data['entity_label'])) {
        data['entity_label'] = 'PERSON';
      } else if(timezoneFields.includes(data['entity_label'])) {
        data['entity_label'] = 'TZ';
      } else if(phoneFields.includes(data['entity_label'])) {
        data['entity_label'] = 'PHONE_NUMBER';
      } else if(numbersFields.includes(data['entity_label'])) {
        data['entity_label'] = 'NUMBER';
      }
      data['entity_label'] = data['entity_label'].toUpperCase();
      this.entityTrainingData['entity_training_data'][data['key']] = data;
      // console.log(JSON.stringify(this.entityTrainingData))
    }

    storeTrainingData(body) {
      if( !body['entity_training_data'] || !Object.keys(body['entity_training_data']).length ) return;
      this._http.post(`${ENV['apiUrl']}/training-data`,{...body}).subscribe((res) => {
        console.info('training_data');
      },(error) => {
        console.info('error');
      })
    }

    getPositionsForContext(target:any,text: any,key: string,actual_key: string) {
      let range = new Range();
          range.setStart( target, 0);
          range.setEnd( target, 0);
          let afterPostions: any = this.getSelectionCharOffsetsWithin(range)
          if(afterPostions['end'] !== null && afterPostions['start'] !== null) {
            afterPostions['end'] = afterPostions['start'] + text.length;
           this.buildTraningData({
              positions: [afterPostions['start'],afterPostions['end']],
              entity_label: key,
              key: actual_key
            })
          }

    }

    /*To find seleted text positions */
    getSelectionCharOffsetsWithin(manualRange?) {
      try {
      const tag = document.getElementById('entityEecognitionTextElement');
      var start = 0, end = 0;
      var sel, range, priorRange;
      if (typeof window.getSelection != "undefined") {
        if(manualRange) {
          range = manualRange;
        } else {
          range = window.getSelection().getRangeAt(0);
        }
        priorRange = range.cloneRange();
        priorRange.selectNodeContents(tag);
        priorRange.setEnd(range.startContainer, range.startOffset);
        //console.log(priorRange,end);
        start = priorRange.toString().length;
        end = start + range.toString().length;
        return {
            start: start,
            end: end
        };
      }
      } catch(e) {
        console.log('error',e);
        return {
          start: null,
          end: null
        }
      }
    }
    findTextPostions() {
      // const selectedText: any = window.getSelection();
      // const tag = selectedText.anchorNode.parentElement;
      // console.log(this.getSelectionCharOffsetsWithin());
      // tag.parentNode.tagName for p3 complier
      // if ((selectedText && tag.tagName === 'P' && tag.getAttribute('id') === 'entityEecognitionTextElement' ) || (selectedText && tag.parentNode.tagName === 'P' && tag.parentNode.getAttribute('id') === 'entityEecognitionTextElement' ) || (selectedText && tag.tagName === 'MARK') ) {
        return {element_found: true,positions: this.getSelectionCharOffsetsWithin()}
      // } else {
        // return {element_found: false};
      // }
    }

    // HTML selection 

    getHTMLOfSelection () {
      var range;
      if (window.getSelection) {
        var selection = window.getSelection();
        if (selection.rangeCount > 0) {
          range = selection.getRangeAt(0);
          if(typeof range.commonAncestorContainer.data == "undefined"){
            var clonedSelection = range.cloneContents();
            var div = document.createElement('div');
            div.appendChild(clonedSelection);
            return {type:"div",element: div.innerHTML};
          }else{
            return {type:"span",label: range.commonAncestorContainer.parentElement.title};
          }
        }
      }
      return '';
    }

    // comman actions for pressing f8 key Word

    commonAction () {
      return;
      const info: any = this.getHTMLOfSelection();
      let titles = [];
      let dynamicElementsCol = [];
      const postions: any = this.findTextPostions();
      if(!postions.element_found) return;
      if(('element' in info && info.element) || ('type' in info && info.type) ) {
        if(info.element) {
          var div = document.createElement('div');
          div.innerHTML = info.element;
          if(div.childNodes) {
            div.childNodes.forEach((dynamicElement: any) => {
              if(dynamicElement.tagName === 'SPAN') {
                if(dynamicElement.hasAttribute('title')) {
                  dynamicElementsCol.push(dynamicElement);
                  titles.push(dynamicElement.getAttribute('title'));
                }
              }
            });
            if(titles.length > 1) {
              return;
            } else{
              // this.traingData(postions,titles[0]);
              console.log(info);
              //this.emitData(titles[0],window.getSelection().toString());
            }
          }
        }
        if(info.type && info.label) {
          console.log(info);
          // this.traingData(postions,info.label);
          //this.emitData(info.label,window.getSelection().toString());
        }
      }
    }

    articleActions(key: string,label: string) {
      return;
      const postions: any = this.findTextPostions();
      console.log('postions', postions);
      if(!postions.element_found) return;
      // if(postions.next)
      // this.traingData(postions,label);
      let data = {};
      data[key] = window.getSelection().toString();
      this.commanService.entityRecongEmit({key: key, data: data})
    }

  // Contextmenu For selected text
    popUpCss = {}
    public isShowPopUp = false;
    public selectedText = '';
    public postions: any = {};
    onRightClick(event) {
      if(window.getSelection().toString()) {
        event.preventDefault();
        event.stopPropagation();
        this.selectedText = window.getSelection().toString();
        const textPostions: any = this.findTextPostions();
        if(textPostions.element_found) {
          this.postions = textPostions;
        }
        this.commanService.emitClearEntityAutoComplete(true); 
        this.isShowPopUp = true;
        let topPos = 0;
        if((event.clientY+280)<(window.innerHeight+window.pageYOffset)){
          topPos=event.clientY;
        }else{
          topPos=event.clientY-280;
        }
        this.popUpCss['left'] =`${event.clientX}px`;
        this.popUpCss['top'] = `${topPos}px`;
        this.popUpCss['display'] = 'block';
            
        setTimeout(()=>{
         if(this.autoCompleteTemplate)
            this.autoCompleteTemplate.focus();
        })
      } else {
        this.isShowPopUp = false;
        this.selectedText = '';
        this.postions = {};
      }
      return false;
    }

    // Event emit to respective form
    eventEmitToEvent(event: string) {
      this.isShowPopUp = false;
      if(this.selectedText) {
        let data = {};
        if(event.indexOf("-") > 0) {
          let eventArray = event.split('-');
          let postion = parseInt(eventArray[eventArray.length-1]);
          data[event.split('-')[0]] =this.selectedText.trim();
          this.commanService.entityRecongEmit({key: event.split('-')[0], data: data, postion:true, positionNumber: postion })
          if('positions' in this.postions && (this.postions.positions['start'] || this.postions.positions['start'] == 0 ) && this.postions.positions['end']) {
            this.buildTraningData({
              positions: [this.postions.positions['start'],this.postions.positions['end']],
              entity_label: event.split('-')[0],
              key: event
            })
          }
        } else {
          data[event] =this.selectedText.trim();
          this.commanService.entityRecongEmit({key: event, data: data})
          if('positions' in this.postions && (this.postions.positions['start'] || this.postions.positions['start'] == 0 ) && this.postions.positions['end']) {
            this.buildTraningData({
              positions: [this.postions.positions['start'],this.postions.positions['end']],
              entity_label: event,
              key: event
            })
          }
        }
      }
    }

    // BuildEntity Recong Fields for Array 
    // Todo Minify the fnction
    public dynamicEntityFields = [];
    public dynamicAddpersonsCompany = [];
    buildEntityConfig(config: any) {
      let values = [];
      let dynamicValues = [];
      if(config['type'] === 'company_database' || config['type'] === 'company_database_update' || config['type'] === 'add_ticker_information') {
        let tickerNonEntites = this.buildEntityFromFields(config['tickers']['controls'],config['type'],'tickers','nonEntityes');
        let irExecutivesEntites = this.buildEntityFromFields(config['ir_executives']['controls'],config['type'],'ir_executives','nonEntityes');
        this.items = [...entityFields[config['type']]['nonEntityes']];
        // [...tickerNonEntites, ...irExecutivesEntites].forEach((item) => {
        //   if(!this.items.includes(item))
        //     this.items.push(item);
        // });
        this.dynamicEntityFields = [...this.buildEntityFromFields(config['tickers']['controls'],config['type'],'tickers','DATE')];
        dynamicValues = this.dynamicEntityFields.map(x => x.title);
        values = [...tickerNonEntites, ...irExecutivesEntites,...dynamicValues]
      }
      if(config['type'] === 'add_persons') {
        let educations= this.buildEntityFromFields(config['educations']['controls'],'add_persons','educations','nonEntityes');
        let work_history = this.buildEntityFromFields(config['work_history']['controls'],'add_persons','work_history','nonEntityes');
        this.items = [...entityFields['add_persons']['nonEntityes']];
        // [...educations, ...work_history].forEach((item) => {
        //   if(!this.items.includes(item))
        //     this.items.push(item);
        // });
        let educationsArray= [...this.buildEntityFromFields(config['educations']['controls'],'add_persons','educations','DATE')];
        this.dynamicAddpersonsCompany = [...this.buildEntityFromFields(config['work_history']['controls'],'add_persons','work_history','ORG')];
        let workHistoryArray= [...this.buildEntityFromFields(config['work_history']['controls'],'add_persons','work_history','DATE')];
        this.dynamicEntityFields = [...educationsArray,...workHistoryArray]
        dynamicValues = this.dynamicEntityFields.map(x => x.title);
        values = [...educations, ...work_history,...dynamicValues]
      }
      if(config['type'] === 'merger') {
        this.dynamicEntityFields = [...this.buildEntityFromFields(config['mergeCompanies']['controls'],'merger','org','ORG')];
        dynamicValues = this.dynamicEntityFields.map(x => x.title);
        values = [...dynamicValues]
      }
      if(config['type'] === 'spin_off') {
        this.dynamicEntityFields = [...this.buildEntityFromFields(config['spinOffCompanies']['controls'],'spin_off','org','ORG')];
        dynamicValues = this.dynamicEntityFields.map(x => x.title);
        values = [...dynamicValues]
      }
      values.forEach((item) => {
        if(!this.items.includes(item))
          this.items.push(item);
      });
      this.commanService.emitAutocompleteItems(this.items);
    };

    buildEntityFromFields (array,type,fieldType,entityType) {
      let items = [];
      array.forEach((formFields,index) => {
        entityFields[type][fieldType][entityType].forEach((item) => {
          if(entityType === 'nonEntityes') {
            items.push(`${item}-${index}`)
          }
          if(entityType === 'DATE') {
            items.push({title:`${item}-${index}`,cmd:`${item}-${index}`})
          }
          if(entityType === 'ORG' && type !== 'add_persons') {
            items.push({title:`${item}-${index+1}`,cmd:`${item}-${index+1}`})
          }
          if(entityType === 'ORG' && type === 'add_persons') {
            items.push({title:`${item}-${index}`,cmd:`${item}-${index}`})
          }
        });
      });
      return items;
    }
    // Actions For Rss And Html

    removeEventListener: Subscription;
    cookieButtonTitle = 'Click Manually Registered'
    timeOutValue: string = '';
    cookiesActionReset: boolean = false;
    scraperUpdate: boolean = false;
    waitValue: string = '';
    removeMouseOverEventListener: Subscription;
    selectArticle: boolean = false;
    selectElementsAction: boolean = false;
    modalRef: BsModalRef;
    selectedView: string = 'article'
    iframeData;
    counter = Array;
    countervalue = 1;
    hrefList : any  = [];
    heading : any  = [];
    summary : any  = [];
    date : any  = [];
    popState = '';
    iframeElemet: HTMLIFrameElement;
    iframeElemtref : HTMLIFrameElement;
    // ['article','link','heading','summary','date'];
    cssSelectors = {
      article: null,
      link: null,
      heading: null,
      summary: null,
      date: null,
      cookies_action: null
    }
  public index = 0;
  public styleSheet = ['article','link','heading','summary','date'];
  public trackingUrlLoading = false;
  public UrlLoading = false;
  iframeActions(iframe: HTMLIFrameElement) {
    var style = iframe.contentDocument.createElement('style');
    // style.type = 'text/css';
    style.innerHTML = `.rssGenHighlighter_border,
    .rssGenHighlighter_borderClone {
      outline: 3px solid #7aa028;
      position: absolute;
      pointer-events: none;
      cursor: pointer;
      z-index: 9999;
    }
    .daggr_dashed {
      border: 2px dashed rgba(211, 211, 211, 0.8);
    }
    .daggr_iframe_detected_dashed {
      border: 3px solid red;
      
    }
    .btn-warning[daggr="daggr_iframe"]:hover {
      cursor: pointer !important;
      border: 3px solid #7aa028 !important;
    }
    .rssGenHighlighter_border_news {
      outline-color: #9BCFDD;
    }
    .rssGenHighlighter_border_title {
      outline-color: #7aa028;
    }
    .rssGenHighlighter_border_content {
      outline-color: #C37070;
    }
    .rssGenHighlighter_border_date {
      outline-color: #9BBCA1;
    }
    .rssGenHighlighter_border_link {
      outline-color: #C9DE95;
    }
    .rssGenHighlighter_border_author {
      outline-color: #EAE160;
    }
    .rssGenHighlighter_border_pic {
      outline-color: #E06031;
    }
    .daggrHighlighter_highlighted {
      cursor: pointer !important;
      border: 3px solid #7aa028 !important;
    }
    .daggrHighlighter_highlightedIE {
      cursor: pointer !important;
      outline: 3px solid #7aa028 !important;
    }
    .daggrHighlighter_highlightedImg {
      opacity: 0.8;
      pointer-events: none;
      position: absolute;
      z-index: 9999;
    }
    .daggrHighlighter_article {
      background: #d4eaf0 !important;
      color: #000000 !important;
    }
    .rssGenHighlighter_type_title {
      background: #a4d044 !important;
      color: #000000 !important;
    }
    .rssGenHighlighter_type_content {
      background: #daa6a6 !important;
      color: #000000 !important;
    }
    .daggr_select {
        background: #5d75cc !important;
        color: #000000 !important;
    }
    .rssGenHighlighter_type_date {
      background: #c9dbcc !important;
      color: #000000 !important;
    }
    .rssGenHighlighter_type_link {
      background: #e7f0cf !important;
      color: #000000 !important;
    }
    .rssGenHighlighter_type_author {
      background: #f3eea4 !important;
      color: #000000 !important;
    }
    .rssGenHighlighter_type_pic {
      background: #ea9373 !important;
      color: #ffffff !important;
    }
    `;
    this.iframeElemet = iframe;
    iframe.contentDocument.getElementsByTagName('head')[0].appendChild(style);
    // detecting iframe for offline html
    let iframeCount: any = iframe.contentDocument.querySelectorAll('iframe');

    iframeCount.forEach(iframeElement => {
      $(iframeElement).addClass('daggr_iframe_detected_dashed');
      let iframeSrc = $(iframeElement).attr('src')
      var anchorNode = document.createElement('a');
      anchorNode.href = this.offlineUiUrl;
      if(!/^http[s]?:\/\//.test(iframeSrc)) {
        if(iframeSrc.indexOf('//',0) === 0) 
          iframeSrc = anchorNode.protocol + iframeSrc;
        else
          iframeSrc = anchorNode.origin + iframeSrc;
      }
      let styles = `
      display: block !important;
      background: #70b3ea;
      color: #ffff;
      border-radius: 2px;
      border: none;
      padding: 4px;
      `;
      // console.log(iframeElement.classList);
      $(iframeElement).before(`<button class='btn-warning' daggr='daggr_iframe' style = "${styles}" title='${iframeSrc.trim()}'>Iframe</button>`);
    });
    if(this.cssSelectors['article'])
      this.updateActions(this.cssSelectors)
    iframe.contentDocument.addEventListener('mouseover',(event: any)=> {
      event.stopImmediatePropagation();
      event.preventDefault();
      event.stopPropagation();
      if(this.selectedView === 'cookies_action') {
        event.target.classList.add('daggrHighlighter_highlighted');
        return;
      }
      if(['HTML','BODY'].includes(event.target.tagName) || this.selectArticle)
        return

      // if(event.target.getAttribute('class')) {
        // if(event.target.className)
          // console.log(event.target.tagName.toLowerCase()+'.'+event.target.getAttribute('class').split(' ')[0]);
          iframe.contentDocument.querySelectorAll(this.getCSSPath(event.target)).forEach((dashedElement: any)=>{
            //console.log(event.target.contains(dashedElement))
            if(event.target.contains(dashedElement)) {
              dashedElement.classList.add('daggrHighlighter_highlighted')
            } else {
              dashedElement.classList.add('daggr_dashed')
            }
          })
      // }  
      // event.target.classList.add('daggrHighlighter_highlighted');
    });
    iframe.contentDocument.addEventListener('mouseout',(event: any)=> {
      const classList = iframe.contentDocument.querySelectorAll('.daggrHighlighter_highlighted') || [];
      this.removeClass(classList,'daggrHighlighter_highlighted');
      this.removeClass(iframe.contentDocument.querySelectorAll('.daggr_dashed') || [],'daggr_dashed');
    });

    iframe.contentDocument.addEventListener('click', (event: any) => {
      event.stopImmediatePropagation();
      event.preventDefault();
      event.stopPropagation();
      if(event.target.getAttribute('daggr') && !this.scraperUpdate) {
          this.detectIframe(event.target.getAttribute('title'))
          this.refTick.tick()
        return;
      }
      if(this.selectedView === 'cookies_action') {
        this.cssSelectors['cookies_action'] = event.target.getAttribute('id') ? `#${event.target.getAttribute('id')}` : this.getCSSPath(event.target);
        this.clickActionRefresh(false);
        this.refTick.tick()
        return;
      }
      if( (['HTML','BODY'].includes(event.target.tagName) || this.selectArticle))
        return

      this.selectArticle = true;
      // this.cdRef.detectChanges();
      this.refTick.tick()
      iframe.contentDocument.querySelectorAll(this.getCSSPath(event.target)).forEach((dashedElement: any)=>{
        if(event.target.contains(dashedElement)) {
          dashedElement.classList.add('daggrHighlighter_article')
        } else {
          dashedElement.classList.add('daggr_select')
        }
      })
      this.countervalue = iframe.contentDocument.querySelectorAll(this.getCSSPath(event.target)).length;
      const classList = iframe.contentDocument.querySelectorAll('.daggrHighlighter_highlighted') || [];
      this.removeClass(classList, 'daggrHighlighter_highlighted');
      this.cssSelectors['article'] = this.getCSSPath(event.target);
      this.index = 1;
      this.selectedView = this.styleSheet[this.index];
      this.refTick.tick()
      // this.cdRef.detectChanges();
      // event.target.classList.add('daggrHighlighter_article');
      if(!this.selectElementsAction)
        this.highlighter_type_news(iframe);
      // iframe.contentDocument.getElementsByClassName('daggrHighlighter_article')[0].addEventListener()
    });
  // iframe.contentDocument.getElementsByClassName('daggrHighlighter_article');
  }

  getCSSPath(el: any) {
    const removeClasses = ['daggrHighlighter_article','daggrHighlighter_highlighted','daggrHighlighter_heading','daggr_dashed','daggr_select','daggr_iframe_detected_dashed']
    // let rendered_path_parts = [];
    // $( el ).parents().addBack().each((i, el) => {
    //     const $el = $( el );
    //     let current_el_path = $el.prop('tagName').toLowerCase();

    //     // if ($el.attr('id')) {
    //     //     current_el_path += '#' + $el.attr('id');
    //     // }

    //     if ($el.attr('class')) {
    //       const cssSelectore = [];
    //       $el.attr('class').split(' ').forEach((className: string) => {
    //           if(!removeClasses.includes(className))
    //             cssSelectore.push(className)
    //       });
    //       if(cssSelectore.length)
    //         current_el_path += '.' + cssSelectore.join('.');
    //     }
    //     rendered_path_parts.push( current_el_path );
    // });
    // return rendered_path_parts.join(' > ');
    let curentTag =  el.tagName.toLowerCase()
    let currentClassName = '';
     // removeClasses.includes(el.getAttribute('class').split(' ')[0]) ?  '' : el.getAttribute('class').split(' ')[0] ?  el.getAttribute('class').split(' ')[0] : '';
    if(el.getAttribute('class')) {
      currentClassName = removeClasses.includes(el.getAttribute('class').split(' ')[0]) ?  '' : el.getAttribute('class').split(' ')[0] ?  el.getAttribute('class').split(' ')[0] : '';
    }
    let parentTag = el.parentNode.tagName.toLowerCase();
    let parentClassName = '';
    if(el.parentNode.getAttribute('class'))
      parentClassName = removeClasses.includes(el.parentNode.getAttribute('class').split(' ')[0]) ?  '' : el.parentNode.getAttribute('class').split(' ')[0] ?  el.parentNode.getAttribute('class').split(' ')[0] : '';
    let superParentTag = '';
    let superParentClassName = '';
    if(!this.cssSelectors['article']) {
      if(el.parentNode.parentNode && el.parentNode.parentNode.getAttribute('class')) {
        superParentTag = el.parentNode.parentNode.tagName.toLowerCase();
        superParentClassName = removeClasses.includes(el.parentNode.parentNode.getAttribute('class').split(' ')[0]) ?  '' : el.parentNode.parentNode.getAttribute('class').split(' ')[0] ?  el.parentNode.parentNode.getAttribute('class').split(' ')[0] : '';
      }
    }
    // let parentClassName = removeClasses.includes(el.parentNode.getAttribute('class').split(' ')[0]) ?  '' : el.parentNode.getAttribute('class').split(' ')[0] ?  el.parentNode.getAttribute('class').split(' ')[0] : '';
    // let parentClassName = el.parentNode.getAttribute('class').split(' ')[0];

    let buildPath = '';
    if(superParentTag)
      buildPath += superParentTag
    if(superParentTag && superParentClassName)
      buildPath += '.'+ superParentClassName

    if(parentTag)
      buildPath += ' ' + parentTag
    if(parentTag && parentClassName)
      buildPath += '.'+parentClassName

    if(this.cssSelectors['article'] && this.index) {
      if(this.cssSelectors['article'].includes(buildPath)) {
        buildPath = ''
      }
    }

    if(curentTag)
      buildPath += ' '+curentTag
    if(currentClassName)
      buildPath += '.'+currentClassName

    return buildPath.trim();
    // return curentTag
  }

  removeClass(classList: any, claaName: string) {
    classList.forEach( (element) => {
      element.classList.remove(claaName);
   })
  }

  highlighter_type_news(iframe: HTMLIFrameElement) {
    this.selectElementsAction = true;
    // console.log(iframe.contentDocument.getElementsByClassName('daggrHighlighter_article')[0])
    if(!iframe.contentDocument.getElementsByClassName('daggrHighlighter_article')[0]) return;
    this.removeMouseOverEventListener = fromEvent(iframe.contentDocument.getElementsByClassName('daggrHighlighter_article')[0], 'mouseover')
    .subscribe( (event:any) => {
      event.stopImmediatePropagation();
      event.preventDefault();
      event.stopPropagation();
      // event.target.classList.add('daggrHighlighter_highlighted');
      // if(event.target.getAttribute('class')) {
        // if(event.target.className)
          // console.log(event.target.tagName.toLowerCase()+'.'+event.target.getAttribute('class').split(' ')[0]);
          const boundaryPath = this.cssSelectors['article'] ? `${this.cssSelectors['article']} ${this.getCSSPath(event.target)}` : this.getCSSPath(event.target);
          iframe.contentDocument.querySelectorAll(boundaryPath).forEach((dashedElement: any)=>{
            // dashedElement.classList.add('daggr_dashed');
            // console.log('event.target.contains(dashedElement)',event.target.contains(dashedElement))
            if(event.target.contains(dashedElement)) {
              dashedElement.classList.add('daggrHighlighter_highlighted')
            } else {
              dashedElement.classList.add('daggr_dashed')
            }
          })
      // }  
    });
    this.removeEventListener = fromEvent(iframe.contentDocument.getElementsByClassName('daggrHighlighter_article')[0], 'click')
    .subscribe( (event:any) => {
      event.stopImmediatePropagation();
      event.preventDefault();
      event.stopPropagation();
      if(this.selectedView === 'cookies_action') {
        this.cssSelectors['cookies_action'] = event.target.getAttribute('id') ? `#${event.target.getAttribute('id')}` : this.getCSSPath(event.target);
        this.clickActionRefresh(false);
        this.refTick.tick()
        return;
      }
      if(this.styleSheet.length <= this.index)
        return
      // console.log(console.log('event',event));
      // console.log(this.index,this.styleSheet.length);
      // this.cdRef.detectChanges();
      this.refTick.tick()
      if(event.target.classList.contains('daggrHighlighter_article'))
        return;
      // event.target.classList.add('daggrHighlighter_heading');
      this.cssSelectors[this.styleSheet[this.index]] = this.getCSSPath(event.target);
        let pathSelcet = {}
        pathSelcet['path'] = this.getCSSPath(event.target);

        if(this.styleSheet[this.index] == 'link')
          this.hrefList = [];
        if(this.styleSheet[this.index] == 'heading')  
          this.heading = [];
        if(this.styleSheet[this.index] == 'summary')
          this.summary = [];
        if(this.styleSheet[this.index] == 'date')
          this.date = [];

        // const boundaryPath = this.cssSelectors['article'] ? `${this.cssSelectors['article']} ${this.getCSSPath(event.target)}` : this.getCSSPath(event.target);
        // iframe.contentDocument.querySelectorAll(boundaryPath).forEach((element => {
        
        //   if(this.styleSheet[this.index] == 'link') {
        //       if(element.getAttribute('href') && element.getAttribute('href') != '#') {
        //           this.hrefList.push(element.getAttribute('href'));
        //           this.refTick.tick()
        //       }
        //     }
        //   else {
        //     if(element.textContent) {
        //       if(this.styleSheet[this.index] == 'heading')
        //         this.heading.push(element.textContent);
        //       if(this.styleSheet[this.index] == 'summary')
        //         this.summary.push(element.textContent);
        //       if(this.styleSheet[this.index] == 'date')
        //         this.date.push(element.textContent);
        //     }
        //     // this.refTick.tick()
        //   }
        // }))
        this.getCssElementInfo(this.cssSelectors['article'],this.getCSSPath(event.target),this.styleSheet[this.index]);
        this.index++;
        this.selectedView = this.styleSheet[this.index];
        this.refTick.tick()
    });
  }

  delete(type: string,id,event) {
    event.preventDefault();
    event.stopPropagation();

    if(type === 'link') {
      this.cssSelectors['link'] = null;
      this.hrefList = [];
      this.refTick.tick()
    } else if(type === 'heading') {
      this.cssSelectors['heading'] = null;
      this.heading = [];
      this.refTick.tick()
    } else if(type === 'summary') {
      this.cssSelectors['summary'] = null;
      this.summary = [];
      this.refTick.tick()
    } else if(type === 'date') {
      this.cssSelectors['date'] = null;
      this.date = [];
      this.refTick.tick()
    } else {
    if(this.removeEventListener) this.removeEventListener.unsubscribe();
    if(this.removeMouseOverEventListener) this.removeMouseOverEventListener.unsubscribe();
    const removeArticleClass = this.iframeElemet.contentDocument.querySelectorAll('.daggrHighlighter_article') || [];
    const removeHeadingClass = this.iframeElemet.contentDocument.querySelectorAll('.daggrHighlighter_heading') || [];
    this.removeClass(removeHeadingClass,'daggrHighlighter_heading');
    this.removeClass(removeArticleClass,'daggrHighlighter_article');
    this.removeClass(this.iframeElemet.contentDocument.querySelectorAll('.daggr_select') || [],'daggr_select');
    this.selectArticle = false;
    this.date = [];
    this.summary = [];
    this.heading = [];
    this.hrefList = [];
    this.countervalue = 1;
    this.selectElementsAction = false;
    this.cssSelectors = {
      article: null,
      link: null,
      heading: null,
      summary: null,
      date: null,
      cookies_action: this.cssSelectors['cookies_action']
    }
    this.refTick.tick()
    // this.cdRef.detectChanges();
    }
    this.selectedView = type;
    this.index = parseInt(id);
    this.refTick.tick()
  }

  modal(type:string, template: TemplateRef<any>,event) {
    event.preventDefault();
    event.stopPropagation();
    this.popState = type;
    // console.log(this.popState)
    // this.cdRef.detectChanges();
    this.refTick.tick()
    this.modalRef = this.modalService.show(template);
    // this.cdRef.detectChanges();
    this.refTick.tick()
  }
  public previewType:string = 'rss';
  public eventInformation:any = {};

  public offlineUiUrl = '';
  getIframData(url: string) {
    this.getIframeDetails = true;
    // this.addRemoveClass('REMOVE','manual-job');
    this.addRemoveClass('ADD','scraping-com');
    this.backward = url;
    let detectCookie = false;
    if(this.offlineUiUrl !== url) {
      this.initRssVariables();
      this.offlineUiUrl = url;
      this.ViewType = 'rss';
      
      // console.log(url);
      this.previewType = 'html';
      let params = {};
      params['url'] = url;
      this.trackingUrlLoading = true;
      // params['timeout'] = 10;
      // params['wait'] = 0.5;
      //https://e6on8dus-splash.scrapinghub.com/render.html?url=http://domain.com/page-with-javascript.html&timeout=10&wait=0.5
      of(url).pipe(mergeMap((url: string) => this._http.get(`${ENV.apiUrl}/offline-ui`,{params: params}))).pipe(mergeMap((res:any)=>{ 
        this.htmlContent = res.html;
        // let postionIndex = res.html.indexOf("<head>");
        // let extralength = '<head>'.length;
        // var anchorNode = document.createElement('a');
        // anchorNode.href = url;
        // let baseHref = `<base href="${anchorNode.origin}">`
        // let iframeText = res.html.substring(0, postionIndex + extralength) + baseHref + res.html.substring(postionIndex + extralength);
        // this.undoRedoStack['undo'] = this.sanitizer.bypassSecurityTrustHtml(iframeText)
        this.undoRedoStack['undo'] = this.sanitizer.bypassSecurityTrustHtml(this.cleaningScriptTags(res,url))
        return  this._http.post(`${ENV.scraperApi}/content-analyser/cookie`,{
          "analyse_content": btoa(unescape(encodeURIComponent(res.html))),
          "source_name": "DAGGR"
        });
      })).pipe(mergeMap((cookies_analyser : any) =>{
          if('data' in cookies_analyser && 'items' in cookies_analyser['data']){
            if(cookies_analyser['data']['items']['analyse_result'].length === 1){
              // this.detectCookie = true;
              detectCookie = true;
              this.cssSelectors['cookies_action'] = cookies_analyser['data']['items']['analyse_result'][0];
              let requestBody = {};
              requestBody['url'] = this.offlineUiUrl;
              requestBody['timeout'] = this.timeOutValue ? parseInt(this.timeOutValue) : 30;
              requestBody['wait'] = this.waitValue ? parseInt(this.waitValue) : 3,
              requestBody['additional_settings'] = {
                timeout: this.timeOutValue ? parseInt(this.timeOutValue) : 30,
                wait: this.waitValue ? parseInt(this.waitValue) : 3,
                manual: [
                  {
                    path : this.cssSelectors['cookies_action'],
                    event: 'click',
                    wait: this.waitValue ? parseInt(this.waitValue) : 3,
                  }
                ]
              }
              this.forward = requestBody;
              return this._http.post(`${ENV.apiUrl}/offline-ui/execute`, requestBody);
            }
          }
          return of({'html' : this.htmlContent});
      }))
      .subscribe((iframedata: any) => {
        // let postionIndex = iframedata.html.indexOf("<head>");
        // let extralength = '<head>'.length;
        // var anchorNode = document.createElement('a');
        // anchorNode.href = url;
        // let baseHref = `<base href="${anchorNode.origin}">`
        // let iframeText = iframedata.html.substring(0, postionIndex + extralength) + baseHref + iframedata.html.substring(postionIndex + extralength);
        setTimeout(() => {
          this.trackingUrlLoading = false;
          this.refTick.tick()
        },100)
        this.iframeData = this.sanitizer.bypassSecurityTrustHtml(this.cleaningScriptTags(iframedata,url));
        if (Object.keys(this.responseData).length !== 0) {
          let htmlbody = this.responseData.company_details.company_data_source_details
          if (this.htmlValue == htmlbody.company_data_source_link) {
            if (htmlbody && htmlbody.event && htmlbody.event.path)
              this.cssSelectors['article'] = htmlbody.event.path
            if (htmlbody && htmlbody.article_url && htmlbody.article_url.path)
              this.cssSelectors['link'] = htmlbody.article_url.path
            if (htmlbody && htmlbody.article_heading && htmlbody.article_heading.path)
              this.cssSelectors['heading'] = htmlbody.article_heading.path
            if (htmlbody && htmlbody.publish_date_time && htmlbody.publish_date_time.path)
              this.cssSelectors['date'] = htmlbody.publish_date_time.path
            // if (htmlbody && htmlbody.summary && htmlbody.summary.path)
            //   this.cssSelectors['summary'] = htmlbody.summary.path
          }
          else {
            document.getElementById('deleteArticleData').click()
          }
          }
        if(!detectCookie)
          this.undoRedoStack['undo'] = this.iframeData;
        if(detectCookie) {
          this.undoEnable = true;
          this.redoEnable = false;
          this.cookieButtonTitle = 'Click Automatically Registered'
          this.undoRedoStack['redo'] = this.iframeData;
        }
        
      },(error: any) => {
        setTimeout(() => {
          this.trackingUrlLoading = false;
          this.refTick.tick()
        },100)
        if(error['url'].includes('/execute')){
          this.cookieButtonTitle = 'Click Automatically Registered';
        }
        if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
          const initialState = {
            errors: error.error.data.errors,
          };
          this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
        }
      })
    }
    this.ViewType = 'rss';
  }

  // resetAction

  clickActionReset() {
    // this.cssSelectors['cookies_action'] = null;
    this.cookiesActionReset = false;
    // this.waitValue = '';
    // this.timeOutValue = '';
  }

  detectIframe(title) {
    this.offlineUiUrl = '';
    this.commanService.dataSource(title);
    this.trackingUrlLoading = true;
  }
  // Refresh Action
  clickActionRefresh(updateAction, refreshOnly= false) {
    this.detectCookie = false;
    this.cookieButtonTitle = 'Click Manually Registered';
    this.iframeData = '';
    let params = {
      url: this.offlineUiUrl,
      wait: this.waitValue ? this.waitValue : "3",
      timeout:  this.timeOutValue ? this.timeOutValue : "30"
    }
    this.addRemoveClass('ADD','scraping-com');
    // this.addRemoveClass('REMOVE','manual-job');
    let api = this._http.get(`${ENV.apiUrl}/offline-ui`,{params: params})
    if( this.cssSelectors['cookies_action']) {
      let requestBody = {};
      requestBody['url'] = this.offlineUiUrl;
      requestBody['timeout'] = this.timeOutValue ? parseInt(this.timeOutValue) : 30;
      requestBody['wait'] = this.waitValue ? parseInt(this.waitValue) : 3,
      requestBody['additional_settings'] = {
        timeout: this.timeOutValue ? parseInt(this.timeOutValue) : 30,
        wait: this.waitValue ? parseInt(this.waitValue) : 3,
        manual: [
          {
            path : this.cssSelectors['cookies_action'],
            event: 'click',
            wait: this.waitValue ? parseInt(this.waitValue) : 3,
          }
        ]
      }
      this.forward = requestBody;
      api = this._http.post(`${ENV.apiUrl}/offline-ui/execute`, requestBody);
    }
     this.UrlLoading = true;
    api.subscribe((iframeData: any) => {
      if(!updateAction) {
        this.selectedView = 'article';
        this.index = 0;
        this.selectArticle = false;
        this.date = [];
        this.summary = [];
        this.heading = [];
        this.hrefList = [];
        this.countervalue = 1;
        this.selectElementsAction = false;
        this.cssSelectors = {
          article: null,
          link: null,
          heading: null,
          summary: null,
          date: null,
          cookies_action: this.cssSelectors['cookies_action']
        }
        if(this.removeEventListener) this.removeEventListener.unsubscribe();
        if(this.removeMouseOverEventListener) this.removeMouseOverEventListener.unsubscribe();
      }
      // setTimeout(() =>{
        this.UrlLoading = false;
      // },)
      // let postionIndex = iframeDate.html.indexOf("<head>");
      // let extralength = '<head>'.length;
      // var anchorNode = document.createElement('a');
      // anchorNode.href = this.offlineUiUrl;
      // let baseHref = `<base href="${anchorNode.origin}">`
      // let iframeText = iframeDate.html.substring(0, postionIndex + extralength) + baseHref + iframeDate.html.substring(postionIndex + extralength);
      this.iframeData = this.sanitizer.bypassSecurityTrustHtml(this.cleaningScriptTags(iframeData,this.offlineUiUrl));
        if(!refreshOnly){
          this.undoRedoStack['redo'] = this.iframeData;
          this.undoEnable = true;
          this.redoEnable = false;
          this.cookiesActionReset = true;
        }
        this.refTick.tick()
    },(error: any) => {
       this.UrlLoading = false;
      if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
        const initialState = {
          errors: error.error.data.errors,
        };
        this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
      }
      this.refTick.tick()
    })
  }

  redoAction() {
    this.iframeData = '';
    this.selectedView = 'article';
    // this.selectedView = 'cookies_action';
    this.index = 0;
    this.selectArticle = false;
    this.date = [];
    this.summary = [];
    this.heading = [];
    this.hrefList = [];
    this.countervalue = 1;
    this.selectElementsAction = false;
    this.cssSelectors = {
      article: null,
      link: null,
      heading: null,
      summary: null,
      date: null,
      cookies_action: this.forward['additional_settings']['manual'][0]['path']
    }
    if (this.removeEventListener) this.removeEventListener.unsubscribe();
    if (this.removeMouseOverEventListener) this.removeMouseOverEventListener.unsubscribe();
    this.cookiesActionReset = true;
    if(ENV.onDemadHtml){
      this.UrlLoading = true;
      this.iframeData = this.undoRedoStack['redo'];
      this.UrlLoading = false;
      this.redoEnable = false;
      this.undoEnable = true;     
    }else{
      let request_body = this.forward;
      let api = this._http.post(`${ENV.apiUrl}/offline-ui/execute`, request_body);
      this.UrlLoading = true;
      api.subscribe((iframeData: any) => {
        this.UrlLoading = false;       
        // let postionIndex = iframeDate.html.indexOf("<head>");
        // let extralength = '<head>'.length;
        // var anchorNode = document.createElement('a');
        // anchorNode.href = this.offlineUiUrl;
        // let baseHref = `<base href="${anchorNode.origin}">`
        // let iframeText = iframeDate.html.substring(0, postionIndex + extralength) + baseHref + iframeDate.html.substring(postionIndex + extralength);
        this.iframeData = this.sanitizer.bypassSecurityTrustHtml(this.cleaningScriptTags(iframeData,this.offlineUiUrl));
        this.redoEnable = false;
        this.undoEnable = true;
        this.refTick.tick()
      }, (error: any) => {
        this.UrlLoading = false;
        if (error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
          const initialState = {
            errors: error.error.data.errors,
          };
          this.modalRef = this.modalService.show(ErrorPopupComponent, { initialState });
        }
        this.refTick.tick()
      })
    }
  }

  undoAction(){
    this.selectedView = 'article';
    this.iframeData = '';
    this.ViewType = 'rss';
    this.previewType = 'html';
    this.selectedView = '';
    this.index = 0;
    this.selectArticle = false;
    this.date = [];
    this.summary = [];
    this.heading = [];
    this.hrefList = [];
    this.countervalue = 1;
    this.selectElementsAction = false;
    this.cssSelectors = {
      article: null,
      link: null,
      heading: null,
      summary: null,
      date: null,
      cookies_action: null,
    }
    if (this.removeEventListener) this.removeEventListener.unsubscribe();
    if (this.removeMouseOverEventListener) this.removeMouseOverEventListener.unsubscribe();
    if(ENV.onDemadHtml){
      this.UrlLoading = true;
      this.iframeData = this.undoRedoStack['undo'];
      this.UrlLoading = false;
      this.redoEnable = true;
      this.undoEnable = false;
    }else{
      let url = this.backward;
      let params = {};
      params['url'] = url;
      this.UrlLoading = true;
      of(url).pipe(switchMap((url: string) => this._http.get(`${ENV.apiUrl}/offline-ui`, { params: params })))
        .subscribe((iframeData: any) => {
          this.UrlLoading = false;
          // let postionIndex = iframeDate.html.indexOf("<head>");
          // let extralength = '<head>'.length;
          // var anchorNode = document.createElement('a');
          // anchorNode.href = url;
          // let baseHref = `<base href="${anchorNode.origin}">`
          // let iframeText = iframeDate.html.substring(0, postionIndex + extralength) + baseHref + iframeDate.html.substring(postionIndex + extralength);
          this.iframeData = this.sanitizer.bypassSecurityTrustHtml(this.cleaningScriptTags(iframeData,url));
          this.redoEnable = true;
          this.undoEnable = false;
          this.refTick.tick()
        }, (error: any) => {
          this.UrlLoading = false;
          if (error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
            const initialState = {
              errors: error.error.data.errors,
            };
            this.modalRef = this.modalService.show(ErrorPopupComponent, { initialState });
          }
          this.refTick.tick()
        })
    }
  }

  ViewAction(type: string) {
    console.log(type)
    this.ViewType = type;
    // console.log('hello',this.ViewType);

  }

  cleaningScriptTags(htmlResponse : any, url: string) {
      let postionIndex = htmlResponse.html.indexOf("<head>");
      let extralength = '<head>'.length;
      var anchorNode = document.createElement('a');
      anchorNode.href = url;
      let baseHref = `<base href="${anchorNode.origin}">`
      let iframeText = htmlResponse.html.substring(0, postionIndex + extralength) + baseHref + htmlResponse.html.substring(postionIndex + extralength);
      let removeScriptTags = this.stripScripts(iframeText,'script');
      let removeNoScriptTags = this.stripScripts(removeScriptTags,'noscript');
      return removeNoScriptTags;
  }

  selectBoundary(id,type,event) {
    event.preventDefault();
    event.stopPropagation();
    if(!this.iframeData)
      return;
    if(id == 0) 
      this.delete(type,id,event)
    if(id != 0 && !this.cssSelectors.article){
      return
    }
    this.index = parseInt(id);
    this.selectedView = this.styleSheet[this.index];
    // console.log(this.index);
  } 

  updateActions(styles: any) {
    let array = this.iframeElemet.contentDocument.querySelectorAll(styles['article']);
    let information = ['link','date','heading','summary'];
    array.forEach((dashedElement: any,index)=>{
      if(index === 0) {
        dashedElement.classList.add('daggrHighlighter_article')
      } else {
        dashedElement.classList.add('daggr_select')
      }
    })
    this.selectArticle = true;
    this.highlighter_type_news(this.iframeElemet);
    this.countervalue = array.length;
    if(styles['link'])
      this.getCssElementInfo(styles['article'],styles['link'].split(`::attr('href')`)[0],'link');
    if(styles['heading'])
      this.getCssElementInfo(styles['article'],styles['heading'].split(`::text`)[0],'heading');
    if(styles['date'])
      this.getCssElementInfo(styles['article'],styles['date'].split(`::text`)[0],'date');
//  if(styles['summary'])
//    this.getCssElementInfo(styles['article'],styles['summary'].split(`::text`)[0],'summary');
    // this.refTick.tick();
  }

  getAnchoreValue(currentElement: any, actualElementPath: string) {
    // let boundaryElement = document.getElementsByClassName();
    let loop = true;
    let acutualElement = currentElement.querySelectorAll(actualElementPath)[0];
    if(acutualElement) {
      if(acutualElement.tagName === 'A') {
        loop = false;
      } else {
        while(loop) {
          if(currentElement.contains(acutualElement)) {
            if(acutualElement.parentElement.tagName === 'A') {
              loop = false
            } else  {
              loop = true;
            }
            acutualElement = acutualElement.parentElement;
          } else {
            loop = false;
          }
        }
      }
    return acutualElement
    } else return null
  }

  getCssElementInfo(boundaryPath: string,elementPath:string,type:string) {
    let selectedPath = boundaryPath ? `${boundaryPath} ${elementPath}` : elementPath;
    let linkTagRef;
    if(type  === 'link') selectedPath = boundaryPath;
    this.iframeElemet.contentDocument.querySelectorAll(selectedPath).forEach((element,index) => {
        if( type== 'link') {
          linkTagRef = this.getAnchoreValue(element,elementPath)
          if( linkTagRef && linkTagRef.getAttribute('href') && linkTagRef.getAttribute('href') != '#') {
            this.hrefList.push(linkTagRef.getAttribute('href'));
          }
          // if(element.getAttribute('href') && element.getAttribute('href') != '#') {
          //     this.hrefList.push(element.getAttribute('href'));
          // }
        } else {
          if(element.textContent) {
            if(type == 'heading')
              this.heading.push(element.textContent);
            if(type == 'summary')
              this.summary.push(element.textContent);
            if(type == 'date') {
              let date = MOMENT(element.textContent, ['DD-MM-YYYY','DD-MMM-YYYY','DD-MMMM-YYYY','MMMM DD YYYY','MMM DD YYYY']).format('YYYY-MM-DD');
              if(date !== 'Invalid date') {
                if(MOMENT(date, 'YYYY-MM-DD', true).isValid()) {
                  this.date.push(date);
                } 
              } else {
                this.date.push(element.textContent);
              }
            }
          }
        }
        // this.refTick.tick()
    });
    if(type  === 'link' && linkTagRef)  this.cssSelectors.link = this.getCSSPath(linkTagRef);
  }
  hilightEntity(clasName) {
    this.removeEntityClasses(this.allClass);
    this.removeClass(document.querySelectorAll('.'+clasName),'enityDisabled');
  }
  toggleEntitiesClassess= true;
  removeEntityClasses(removedClass:string[]) {
    removedClass.forEach((className) => {
        const addNewClass = document.querySelectorAll('.'+className);
        addNewClass.forEach((element) => {
          element.classList.add('enityDisabled');
        })
    })
  }
  removeAllClass(className,removeClassName) {
    const removeClasses = document.querySelectorAll('.' + className);
      removeClasses.forEach((element) => {
          element.classList.remove(removeClassName)
        })
  }
  toggleEntityes() {
    if(this.toggleEntitiesClassess) {
        this.removeAllClass('enityDisabled','enityDisabled')
        this.toggleEntitiesClassess = false;
    } else {
      this.removeEntityClasses(this.allClass)
      this.toggleEntitiesClassess = true;
    }
  }
  focusElement(type: string) {
    this.removeEntityClasses(this.allClass);
    if(type === 'companyId') {
      this.removeAllClass('org','enityDisabled');
      return;
    }
    if(type && this.selectedEventTypeName){
      [...entityFields[this.selectedEventTypeName][type]].forEach((name)=> {
        this.removeAllClass(name,'enityDisabled')
      })
    }

  }

  //Initiate variables Every Event
  initArticleVariable() {
    this.init ='';
    this.entityTrainingData = {
      text: '',
      entity_training_data: {}
    };
    this.invalidJobreason = {};
    this.multipleJob = false;
    this.scraper_file_id = '';
    this.verifyCompanyActionsJobDetails = {};
    this.manualDataSourceJobDetails = {};
    this.dataggDataSourceJobDetails = {};
    this.snapShotDetails = {};
    this.companyDetails = {};
    this.manualDataSourceDetails = { company_id : '', company_name: ''};
    this.dataggDataSourceDetails = { company_id : '', company_name: ''};
    this.dataSourceValidatePrediction = false;
    this.selectElementsAction = false;
    this.eventsToggleActions = false;
    this.text = '';
    this.fileUploadSuccess = false;
    this.manualUploadFileStatus = false;
    this.entityRecognitionFields = {};
    this.scraperId = '';
    this.sourceUrl = '';
    this.iframeUrl = '';
    this.entityText = '';
    this.markdown = '';
    this.jobId = '';
    this.items =  []
    // this.articleViweName = 'markdown';
    this.selectedEventTypeName = '';
    this.manualJob = false;
    this.saveUrlLink = '';
    this.previousId = '';
    this.predicted_event = '';
    this.jobDetailsType = '';
    this.saveUrlId ='';
    this.showRefreshButton = false;
    this.canNavigate = true;
  }

  // Initiate Rss and Html vaiables

  initRssVariables() {
    this.cookiesActionReset = false;
    this.selectElementsAction = false;
    this.offlineUiUrl = '';
    this.cookieButtonTitle = 'Click Manually Registered'
    this.trackingUrlLoading = false;
    this.selectArticle = false;
    this.selectElementsAction = false;
    this.selectedView = 'article';
    this.UrlLoading = false;
    this.redoEnable = false;
    this.undoEnable = false;
    this.detectCookie = false;
    this.scraperUpdate = false;
    this.backward;
    this.forward; 
    this.htmlContent;
    this.undoRedoStack = { undo : '', redo: ''};
    this.iframeData = '';
    this.counter = Array;
    this.countervalue = 1;
    this.hrefList  = [];
    this.heading = [];
    this.summary = [];
    this.date = [];
    this.popState = '';
    this.cssSelectors = {
      article: null,
      link: null,
      heading: null,
      summary: null,
      date: null,
      cookies_action: null
    }
    this.index = 0;
    if(this.removeEventListener) this.removeEventListener.unsubscribe();
    if(this.removeMouseOverEventListener) this.removeMouseOverEventListener.unsubscribe();
    this.ViewType = 'arcticle';
    this.previewType = 'rss';
    this.timeOutValue = '';
    this.waitValue = '';
  }

  //Handle Manual Jobs
  public manualJob = false;
  public manualJobId = '';

  createManualJob(details: any,dataSourceAuditTrailAction = false, formName = '') {
    this.initRssVariables();
    this.initArticleVariable();
    let body = {};
    this.manualJobId =  UUID()
    this.spinner.show();
    if(!Object.keys(details).length) {
      body = {
        service_type: 'MANUAL_JOB',
        source_id: this.manualJobId,
        source_type: 'DAGGR',
        job_details: {
            source_id: this.manualJobId,
            source_type: 'DAGGR'
        }
      }
    } else {
      body = {
        service_type: 'MANUAL_JOB_EDIT',
        source_id: details['id'],
        source_type: details['type'],
        job_details: {
            source_id: details['id'],
            source_type: details['type']
        }
      }
    }
    this.stopManulJobPost = this._http.post(`${ENV.workItemsApi}/jobs`,body).subscribe( (data: any) => {
      this.auditTrailJobStateActions({action_type:'JOB_STARTED',source_id: data['data']['items']['id']});
      if(dataSourceAuditTrailAction && formName) {
        setTimeout( () => {
          this.auditTrailJobStateActions({action_type:'FORM_OPEN',form_name: formName,source_id: data['data']['items']['id']});
        },300)
      }
      this.jobId = data['data']['items']['id'];
      this.jobStatus = 'IN_PROGRESS';
      this.canNavigate = false;
      this.manualJob = true;
      this.jobtype = 'WORK_ITEM';
      this.jobDetailsType = data.data.items.service_type;
      this.spinner.hide();
    },(error: HttpErrorResponse) => {
      this.spinner.hide();
      if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
        const initialState = {
          errors: error.error.data.errors,
        };
        this.canNavigate = true;
        this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
      }
    })
  }
  // Handle manul job urls
  public saveUrlLink = '';
  saveUrl(values: any) {
    this.fileUploadSuccess = false;
    if(values.url!== this.saveUrlLink) {
      this.saveUrlLink = values.url;
        let body = {
          "source_id": this.jobId,
          "source_type": "DAGGR_REF_WORKITEM",
          "status": "ACTIVE",
          "enable_crawlera": false,
      }
      if(values['url']) body['url'] = values['url'];

      let apiUrl = `${ENV.scraperApi}/save-url`;

      if(values['file']) apiUrl = `${apiUrl}?upload_file=true`;

      this.stopSaveUrl = this._http.post(apiUrl,body).subscribe((data : any) => {
        if(data['data']['items']['upload_file_presigned_url']) {
          const httpHeaders = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': values['file_content_type']
          });
          const options = {
            headers: httpHeaders,
          };
          this._http.put(`${data['data']['items']['upload_file_presigned_url']}`, values['file'], options).subscribe((res) => {
            // this.fetchOfflineUrl(data['data']['items']['id']);
            this.manualUploadFileStatus = true;
            if(!this.isEventFailed) {
              this.validateFiles.disable();
            }
            // this.updateWorkItemWithScraperId(data['data']['items']['id']);
            this.fileUploadSuccess = true;
          },(error) => {
            console.log(error)
          })
        }
        else {
          this.fileUploadSuccess = true;
          if(!this.isEventFailed) {
            this.validateFiles.disable();
          }
          // this.fetchOfflineUrl(data['data']['items']['id']);
          this.manualUploadFileStatus = true;
          // this.updateWorkItemWithScraperId(data['data']['items']['id']);
        }
      },(error) => {
      })
   }
  }

  // Fetching save Url
 public previousId = '';

 fetchOfflineUrl(id: string) {
   if(id !== this.previousId || !(this.count <= 6) ) {
     this.previousId = id;
     this.count = 0
      this.showRefreshButton = false;
      if(this.timeOut)
        clearTimeout(this.timeOut)
      if(this.stopPolling) {
          this.stopPolling.unsubscribe();
      }
   }
   if(!(this.count <= 6)) {
    this.showRefreshButton = true;
    this.saveUrlId = id;
    this.count = 0
    return
  };
   this.stopPolling = this._http.get(`${ENV.scraperApi}/save-url/${id}`).subscribe((urlInfo : any) => {
    // console.log(urlInfo['data']['items']);
    this.showRefreshButton = false;
     if(urlInfo['data']['items']['job_status'] !== 'COMPLETED') {
       this.timeOut = setTimeout(() => {
         this.count += 1;
         this.fetchOfflineUrl(id);
       },10000)
     } else {
       if(this.timeOut)
        clearTimeout(this.timeOut)
       this.getScraperJobDetails(urlInfo['data']['items']['files_id']);
     }
   })
 }
 // Updating workItem 
 updateWorkItemWithScraperId(saveUrlId: string) {
  let job_details = {
    source_id: this.manualJobId,
    source_type: 'DAGGR',
    scraper_save_url_id: saveUrlId,
    type:'MANUAL'
  }
  this._http.put(`${ENV.workItemsApi}/jobs/${this.jobId}`,{job_details: job_details}).subscribe((data: any) => {
    this.jobDetailsType = data.data.items.service_type;
  },(error: HttpErrorResponse) => {
    if( error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
      const initialState = {
        errors: error.error.data.errors,
      };
      this.modalRef = this.modalService.show(ErrorPopupComponent, {initialState});
    }
  })
 }

 // companyACtions 
 verifyActions(type: string,compnay_action: string,id: string) {
  const initialState = {
    details: {
      actions_type: type,
      compnay_action:compnay_action,
      id: id,
      source_id: this.jobId
    },
  };
  this.modalRef = this.modalService.show(VerifyActionsComponent, {initialState});
}

validateRss(url) {
  let params = new HttpParams(); 
  params = params.append('rssURL', url);
  return this._http.get(`${ENV.apiUrl}/rssvalidate`, { params }) 
}
  addRemoveClass(actionType: string,className: string) {
    if(!className || !actionType) return 
    const nativeElement: any  = document.getElementsByTagName('body')
    if(actionType == 'ADD') {
      nativeElement[0].classList.add(className);
    } else if(actionType == 'REMOVE') {
      nativeElement[0].classList.remove(className);
    }
  }

  showAfterConfirmTemplate(popUp, jobComplete=false){
    let config = {
      class:'modal-dialog-centered',
      ignoreBackdropClick: true,
      keyboard: false
    }
    if(!jobComplete){
      this.jobStatus = 'COMPLETED';
    }
    this.modalRef = this.modalService.show(popUp, config);
    setTimeout(()=>{
      this.modalRef.hide();
      this.multipleJob=false;
    },3000);
  }

  //job state function
  async jobState(popUp, type: string, fromGuard= false, confrimTemplate?, endpoint?, logout=false){
    let body = {};
    this.spinner.show();
    if (!['MANUAL_JOB','MANUAL_JOB_EDIT'].includes(this.jobDetailsType)) {
      let config = {
        keyboard: true,
        backdrop: true,
        ignoreBackdropClick: true,
        class: 'modal-dialog-centered'
      };
      try {
        let params =  { job_status: 'IN_PROGRESS' };
        let getResponse:any = await this._http.get(`${ENV.workItemsApi}/jobs/${this.jobId}`,{params: params}).toPromise();
        if(getResponse['data']['items']['user_queue_name'] !== `COGNITO_SUB:${this.auth.getIdToken.sub}:${getResponse['data']['items']['queue_name']}:IN_PROGRESS`) {
          this.modalService.show(JobCheckComponent, config)
          this.spinner.hide()
          return
        }
        
      } catch(error) {
        this.modalService.show(JobCheckComponent, config)
        this.spinner.hide()
        return;
      }
    }
    if (this.jobId) {
      body['reference_id'] = this.jobId;
      body['reference_type'] = this.jobtype
    }
    if (this.scraperId) {
      body['source_id'] = this.scraperId;
      body['source_type'] = 'SCRAPER';
    }
    body['job_state'] = type;
    if(Object.keys(this.invalidJobreason).length) {
      body['invalid_job_reason'] = this.invalidJobreason;
      body['invalid_job'] = true;
    }
    this.http.create('job-state', body).subscribe((data: any) => {
      // this.spinner.hide();
      this.canNavigate = true;
      if(fromGuard){
        this.spinner.hide();
        this.jobStatus = 'COMPLETED';
        return false;
      }
      if(confrimTemplate){
        this.spinner.hide();
        this.showAfterConfirmTemplate(confrimTemplate);
        if(endpoint){
          this.router.navigateByUrl(`template2/${endpoint}`);
          return false;
        }
        if(logout){
          this.auditTrailLoginActions('SIGN_OUT',{action_type:'SIGN_OUT'});
          return false;
        }
      }
      if (type==="SKIPPED") {
        // this.workItems.auditTrailJobStateActions({action_type:'JOB_SKIPPED',source_id: this.workItems.jobId});
        this.resetEventInfo(true);
      } else{
        this.resetEventInfo();
      }
      this.dataSourceValidatePrediction = false;
    }, (error: HttpErrorResponse) => {
      this.spinner.hide();
      if (error.status === 400 && 'data' in error.error && 'errors' in error.error.data) {
        const initialState = {
          errors: error.error.data.errors,
        };
        this.modalRef = this.modalService.show(ErrorPopupComponent, { initialState });
      }
    })
  }
  
}
